export default __webpack_public_path__ + "static/Mesquita_image@2x-936b2fec429ee0ef5cccf1e0d544018c.png";